module.exports = __webpack_public_path__ + "img/23.8d32ad46.png";